<template>
    <component :is="tag">
        <slot
            :proposalStep="step"
            :campaign="campaign"
            :proposal="proposal"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :isLoading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :patch-proposal-step="patchProposalStep"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "../mixins/BaseProposalStepMixin";
    import {NAME_TASKS} from '../../../constants/proposal-steps';

    export default {
        name: 'TasksProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        computed: {
            step() {
                return this.proposalSteps[NAME_TASKS];
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposal(true),
                    ]);
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>
